import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnPlateDetail extends SnModel {
  @Expose({ name: 'Camera Name' })
  public cameraName: string;

  @Expose({ name: 'Camera ID' })
  public cameraId: string;

  @Expose({ name: 'Company ID' })
  public companyId: string;

  @Expose({ name: 'Overview Image' })
  public overviewImage: string;

  @Expose({ name: 'Patch Image' })
  public patchImage: string;

  @Expose({ name: 'Plate' })
  public plate: string;

  @Expose({ name: 'Travel Direction' })
  public travelDirection: number;

  @Expose({ name: 'Vehicle Color' })
  public vehicleColor: string;

  @Expose({ name: 'Vehicle Make' })
  public vehicleMake: string;

  @Expose({ name: 'Vehicle Model' })
  public vehicleModel: string;

  @Expose({ name: 'Vehicle Orientation' })
  public vehicleOrientation: string;

  @Expose({ name: 'Vehicle Year' })
  public vehicleYear: string;

  @Expose({ name: 'Confidence' })
  public confidence: number;

  @Expose()
  public plateAnalytics: any;

  @Expose()
  public alertType: string;

  @Expose()
  public dateOfTheft: string;

  @Expose()
  public ncicNumber: string;

  @Expose()
  public oriNumber: string;

  @Expose()
  public oriState: string;

  @Expose()
  public plateState: string;

  @Expose()
  public plateType: string;

  @Expose()
  public plateYear: string;

  @Expose()
  public reason: string;

  @Expose()
  public direction: string;

  @Expose({ name: 'Lane Name' })
  public laneName: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
